module.exports = __webpack_public_path__ + "fonts/Alga-LightItalic.7b71a8e2.eot";